import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IDtoBudgetList } from 'app/shared/models/quote/dto-budget-list.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-modal-budget-versions',
    templateUrl: './modal-versions.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalBudgetVersionsComponet implements OnInit {
    /**Variables */
    private budgetsList: IDtoBudgetList[];
    constructor(private bsModalRef: BsModalRef
        , private router: Router
        , private route: ActivatedRoute) {
    }
    ngOnInit(): void {
    }
    private navigateTo(row: IDtoBudgetList): void {
        this.bsModalRef.hide();
        this.router.navigate(['/budgets/create',
            { id: row.id, action: 'update' }], { relativeTo: this.route });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
